<template>
  <div class="email-list-input">
    <label v-if="label" class="font-weight-bold">{{ label }}</label>

    <div class="input-group">
      <input
        v-model.trim="novoEmail"
        type="email"
        class="form-control"
        :class="{ 'is-invalid': invalidState }"
        :placeholder="placeholder"
        :disabled="disabled"
        @keydown.enter.prevent="adicionar"
      />
      <div class="input-group-append">
        <button
          type="button"
          class="btn btn-light-primary"
          :disabled="disabled"
          @click="adicionar"
        >
          <i class="fa fa-plus mr-1"></i>
          Adicionar
        </button>
      </div>
    </div>

    <small v-if="erroLocal" class="text-danger d-block mt-1">
      {{ erroLocal }}
    </small>
    <small v-else-if="error" class="text-danger d-block mt-1">
      {{ error }}
    </small>

    <div class="email-list-input__chips mt-2">
      <span
        v-for="email in emails"
        :key="email"
        class="badge badge-light border mr-2 mb-2"
      >
        {{ email }}
        <button
          type="button"
          class="btn btn-xs btn-icon ml-1"
          :disabled="disabled"
          :aria-label="`Remover ${email}`"
          @click="remover(email)"
        >
          <i class="fa fa-times"></i>
        </button>
      </span>
    </div>
  </div>
</template>

<script>
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: "EnvioContabilidadeEmailListInput",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "contador@example.com",
    },
    error: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      novoEmail: "",
      erroLocal: "",
    };
  },
  computed: {
    emails() {
      return Array.isArray(this.value) ? this.value : [];
    },
    invalidState() {
      return Boolean(this.erroLocal || this.error);
    },
  },
  methods: {
    adicionar() {
      const email = this.novoEmail.trim().toLowerCase();
      this.erroLocal = "";

      if (!email) {
        return;
      }

      if (!EMAIL_REGEX.test(email)) {
        this.erroLocal = "Informe um e-mail válido.";
        return;
      }

      if (this.emails.includes(email)) {
        this.erroLocal = "Este e-mail já foi adicionado.";
        return;
      }

      this.$emit("input", [...this.emails, email]);
      this.novoEmail = "";
    },
    remover(email) {
      this.$emit(
        "input",
        this.emails.filter(item => item !== email)
      );
    },
  },
};
</script>

<style scoped>
.email-list-input__chips .badge {
  font-size: 0.9rem;
  padding: 0.45rem 0.65rem;
}

.btn-xs {
  height: 18px;
  width: 18px;
  line-height: 18px;
  padding: 0;
}
</style>
